module.exports = __webpack_public_path__ + "laugh.png?c74af6252e85c869a6c776316af9184b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/laugh.png
// module id = 256
// module chunks = 0